(function () {
  'use strict';

  function registrationSelectorController($scope, $log, $timeout, $rootScope, $location, $window,
    $filter, registrationConfiguration) {

    var vm = this;
    vm.registrationConfiguration = registrationConfiguration;

    if (vm.registrationConfiguration.Entities) {
      vm.registrationConfiguration.Entities.forEach(function (entity, index) {
        entity.formattedEntityType = $filter('splitToWords')(entity.EntityType)
          .replace(' ','_')
          .toLowerCase();
      });
    };

    vm.registrationGroups = [];

    for (var i = 0; i < vm.registrationConfiguration.Entities.length; i+= 3) {
      var group = {
        tileClass: '',
        entities: []
      }
      switch (vm.registrationConfiguration.Entities.length - i)
      {
          case 1:
              group.tileClass = "one-in-row";
              break;
          case 2:
              group.tileClass = "two-in-row";
              break;
          default:
              group.tileClass = "three-in-row";
              break;
      }

      for (var j = 0;
        j < Math.min(
          vm.registrationConfiguration.Entities.length - i, 3);
          j++)
        {
            var tileIndex = i + j;
            group.entities.push(vm.registrationConfiguration.Entities[tileIndex]);
        }

        vm.registrationGroups.push(group);
    }
    // var vm = this;
    // vm.sessionData = sessionData;
    // vm.statesList = STATES_LIST;
    // vm.platformEntityTypes = platformEntityTypes;

    // function formatEntityType(entityType) {
    //   var formatted = '';
    //   var wasPreviousCharSeparator = true;
    //   for (var i = 0; i < entityType.length; i++) {
    //     var charVal = entityType.substring(i, i + 1);
    //     if (wasPreviousCharSeparator) {
    //       formatted = formatted + charVal.toUpperCase();
    //       wasPreviousCharSeparator = false;
    //     } else if (charVal === '_') {
    //       formatted = formatted + ' ';
    //       wasPreviousCharSeparator = true;
    //     } else {
    //       formatted = formatted + charVal;
    //       wasPreviousCharSeparator = false;
    //     }
    //   }

    //   return formatted;
    // }

    // vm.entityType = formatEntityType($rootScope.$state.params.entityType);

    // vm.model = {
    //   AccountType: vm.entityType.replace(' ','')
    // };

    // vm.errors = [];
    // vm.submit = function() {
    //   vm.hideButtons = true;
    //   if (!vm.model.CompanyDetails.State) {
    //     vm.errors = ["State is missing"];
    //     return;
    //   }

    //   if (vm.model.AccountType === "PlatformEntity" && !vm.model.EditableEntityType) {
    //     vm.errors = ["EntityType is missing"];
    //     return;
    //   }

    //   return entityDataService.createEntity(vm.model).then(
    //     function (result) {
    //       if (result.isError) {
    //         vm.errors = [];
    //         Object.keys(result.data.Errors).forEach(function(key) {
    //           vm.errors = vm.errors.concat(result.data.Errors[key]);
    //         });
    //         vm.hideButtons = false;
    //       }
    //       else {
    //         vm.hideButtons = true;
    //         vm.errors = [];
    //         notifyService.notify('The new account was created successfully and the user was sent a registration email. You are being redirected to your dashboard.');
    //         $timeout(function () {
    //           $window.location = '/crm/accounts/details/' + result.EntityId.toLowerCase();
    //         }, 2000);
    //       }
    //     }
    //   )
    // }
  }

  registrationSelectorController.$inject = [
    '$scope', '$log', '$timeout', '$rootScope', '$location', '$window', '$filter',
    'registrationConfiguration'
  ];

  angular.module('ecap.registration').controller('registrationSelectorController', registrationSelectorController);
})();